export class ServiceFilterbarData {
    name: string;

    creatorName: string;

    category: string;

    status: string;
}
